export default __webpack_public_path__ + "static/media/next-icon.3dad94d4.svg";